export default __webpack_public_path__ + "static/media/emptyCollection.7b24aba0.png";